import { render, staticRenderFns } from "./AttachmentStatusLabel.vue?vue&type=template&id=41ecfad6&scoped=true"
import script from "./AttachmentStatusLabel.vue?vue&type=script&lang=ts"
export * from "./AttachmentStatusLabel.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentStatusLabel.vue?vue&type=style&index=0&id=41ecfad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ecfad6",
  null
  
)

export default component.exports